/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unreachable */
/* eslint-disable default-case */
import { CustomButton, CustomCollapseCard, CustomImage, errorDialog, Text, useText } from '@src/components';
import '@src/styles/balanceUpload/excelUpload.scss';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Upload } from 'antd';
import downloadIcon from '@src/assets/icons/icon-download.svg';
import download from 'js-file-download';
import dayjs from '@src/utils/day';
import { getFileNameByLanguage } from '@src/utils/utils';
import {
  createExcelGroupErrors,
  excelUploadPrimaryColumn,
  getAllLoadBalanceCards,
  loadBalanceDetailExcelTemplate,
  loadBalanceDetailExcelUpload,
  resetExcelUploadErrorMessages,
  resetExcelUploadExcelErrorGroupMessages,
  setExcelUploadStatus,
  setSelectedBalanceUploadDetails,
} from '@src/store/slice/balanceUploadDetailSlice';
import errorUpload from '@src/assets/icons/np_warning_189701_000000.png';
import ExcelUploadColumnChoiceModal from '@src/pages/ticketRestaurant/balanceUpload/balanceInformation/ExcelUploadColumnChoice';
import xlsx from '@src/utils/xlsx';
import ExcelUploadTable from '@src/pages/ticketRestaurant/balanceUpload/balanceInformation/ExcelUploadTable';
import iconSuccess from '@src/assets/icons/icon-success.svg';
import iconFail from '@src/assets/icons/icon-fail.svg';
import { setShowLoader, setSpinText } from '@src/store/slice/appSettingsSlice';
import { setExcelNoError, setSelectedRowKeys } from '@src/store/slice/balanceUploadSlice';
import { Walktour } from 'walktour';
import modalClose from '@src/assets/icons/icon_close_black.svg';
import PropTypes from 'prop-types';
import { VouIdCode } from '@src/store/enums';

export const templateExcel = (firstRow, excelData, periodType) => {
  let returnValue = 'SpecialExcel';
  const text = Object.values(firstRow).join(';;;');
  if (
    text === 'Teslimat Adresi;;;Kart Numarası;;;Ad;;;Soyad;;;Referans Numarası;;;Aylık Tutar' &&
    periodType === 1
  ) {
    returnValue = 'MountlyExcel';
  }
  if (
    text ===
    'Teslimat Adresi;;;Kart Numarası;;;Ad;;;Soyad;;;Referans Numarası;;;Gün Sayısı;;;Günlük Tutar' &&
    periodType === 0
  ) {
    returnValue = 'DailyExcel';
  }
  if (firstRow.hasOwnProperty('B') && firstRow['B'] === 'Kart Numarası') {
    const hasCardData = excelData
      .filter((_, i) => i !== 0)
      .map((item) => item.hasOwnProperty('B'))
      .some((item) => item === true);
    if (!hasCardData) {
      returnValue = 'SpecialExcel';
    }
  }
  return returnValue;
};

const alphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
const getColumns = (count) => {
  return alphabets
    .map((item, index) => ({ id: index + 1, label: item, align: 'center' }))
    .slice(0, count);
};

async function MountlyExcel(
  excelParams,
  file,
  dispatch,
  afterUpload,
  vouId,
  isCompliments = false,
) {
  excelParams.current = {
    FormFile: file,
    FirstRowHeaderColumn: true,
    UseDefaultTemplate: true,
    PeriodType: 1,
    RefNoColumn: isCompliments ? 5 : null,
    DayCountColumn: null,
    PriceColumn: isCompliments ? 3 : null,
    vouId: vouId,
    CardNumberColumn: null,
  };
  await dispatch(
    setSpinText(`${file.name} <br/> <span style="color: #00a483">yükleniyor..</span>`),
  );
  await dispatch(setShowLoader(true));
  try {
    await dispatch(loadBalanceDetailExcelUpload(excelParams.current));
    await dispatch(
      excelUploadPrimaryColumn({
        type: 'cardNumber',
        FirstRowHeaderColumn: true,
        column: 'B',
        dailyColumn: null,
        priceColumn: 'F',
        periodType: 1,
      }),
    );
    await afterUpload();
  } finally {
    await dispatch(setSpinText(''));
    await dispatch(setShowLoader(false));
  }
}

async function DailyExcel(excelParams, file, dispatch, afterUpload, vouId) {
  excelParams.current = {
    FormFile: file,
    FirstRowHeaderColumn: true,
    UseDefaultTemplate: true,
    PeriodType: 0,
    RefNoColumn: null,
    DayCountColumn: null,
    PriceColumn: null,
    CardNumberColumn: null,
    vouId: vouId,
  };
  await dispatch(
    setSpinText(`${file.name} <br/> <span style="color: #00a483">yükleniyor..</span>`),
  );
  try {
    await dispatch(setShowLoader(true));
    await dispatch(loadBalanceDetailExcelUpload(excelParams.current));
    await dispatch(
      excelUploadPrimaryColumn({
        type: 'cardNumber',
        FirstRowHeaderColumn: true,
        column: 'B',
        dailyColumn: 'F',
        priceColumn: 'G',
        periodType: 0,
      }),
    );
    await afterUpload();
  } finally {
    await dispatch(setSpinText(''));
    await dispatch(setShowLoader(false));
  }
}

async function SpecialExcel(decodedExcelFile, setColumns, setIsOpenExcelColumnChoiceModal) {
  const columnsData = getColumns(Object.keys(decodedExcelFile.current[0]).length);
  setColumns(columnsData);
  setIsOpenExcelColumnChoiceModal(true);
}

const ExcelUpload = ({ isCompliments = false, isMarket = false }) => {
  const lastUploadedFile = useRef(null);
  const decodedExcelFile = useRef([]);
  const excelParams = useRef({
    FormFile: null,
    CardNumberColumn: null,
    RefNoColumn: null,
    DayCountColumn: null,
    PriceColumn: null,
    FirstRowHeaderColumn: null,
    UseDefaultTemplate: false,
    PeriodType: null,
  });
  const dispatch = useDispatch();
  const { currentLoadBalance } = useSelector((state) => state?.balanceUpload);
  const { excelUploadErrorMessages, excelUploadExcelErrorGroupMessages, isFirstExcelUpload } =
    useSelector((state) => state?.balanceUploadDetail);
  const [isOpenExcelColumnChoiceModal, setIsOpenExcelColumnChoiceModal] = useState(false);
  const [columns, setColumns] = useState([]);
  const [isUploadedExcelFile, setIsUploadedExcelFile] = useState(false);
  const [uploadedExcelFile, setUploadedExcelFile] = useState('');
  const pleaseUploadXlsxFormatFile = useText('pleaseUploadXlsxFormatFile');
  const fixTheseErrorsToContinueBalanceLoading = useText('fixTheseErrorsToContinueBalanceLoading');
  const fixErrorsInYourUploadedExcelAndReupload = useText('fixErrorsInYourUploadedExcelAndReupload');
  const youCanAlsoFixErrorsByEditingRedMarkedAreas = useText(
    'youCanAlsoFixErrorsByEditingRedMarkedAreas',
  );
  const previousLabel = useText('previous');
  const nextLabel = useText('next');
  const closeLabel = useText('close');
  const excelUploadAreaTitle = useText('excelUploadAreaTitle');

  const vouId = useMemo(() => {
    if (isMarket) return VouIdCode.Market;
    if (isCompliments) return VouIdCode.Compliments;
    return VouIdCode.Restaurant;
  }, [isMarket, isCompliments]);

  useEffect(async () => {
    await dispatch(resetExcelUploadErrorMessages());
    await dispatch(resetExcelUploadExcelErrorGroupMessages());
    await dispatch(setExcelUploadStatus(false));
  }, []);

  useEffect(async () => {
    setIsUploadedExcelFile(false);
    setUploadedExcelFile(false);
    await dispatch(resetExcelUploadErrorMessages());
    await dispatch(resetExcelUploadExcelErrorGroupMessages());
    await dispatch(setExcelUploadStatus(false));
  }, [currentLoadBalance?.periodType]);

  useEffect(() => {
    if (currentLoadBalance?.id) {
      dispatch(
        getAllLoadBalanceCards({
          loadBalanceId: currentLoadBalance?.id,
          vouId: vouId,
        }),
      );
    }
  }, [currentLoadBalance]);

  const downloadActiveCards = useCallback(async () => {
    const action = await dispatch(
      loadBalanceDetailExcelTemplate({
        vouId: vouId,
        periodType: currentLoadBalance?.periodType,
      }),
    );
    if (loadBalanceDetailExcelTemplate.fulfilled.match(action)) {
      download(
        action?.payload,
        `${getFileNameByLanguage('bakiye-yukleme', 'balance-loading')}-${dayjs().format('DD-MM-YYYY hh:mm')}.xlsx`,
      );
    }
  }, [currentLoadBalance, dispatch]);

  const afterUpload = useCallback(async () => {
    setIsUploadedExcelFile(true);
    setUploadedExcelFile(excelParams.current.FormFile.name);
    await dispatch(setExcelUploadStatus(true));
  }, [dispatch, currentLoadBalance]);

  const getRows = (e) => {
    const data = new Uint8Array(e.target.result);
    const workbook = xlsx.read(data, { type: 'array' });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const rows = [];
    setIsUploadedExcelFile(false);
    for (const z in worksheet) {
      if (z.startsWith('!')) continue;
      let tt = 0;
      for (let i = 0; i < z.length; i++) {
        if (!isNaN(z[i])) {
          tt = i;
          break;
        }
      }
      const row = parseInt(z.substring(tt));
      const value = worksheet[z].v;
      if (!rows[row]) rows[row] = {};
      rows[row][z.charAt(0)] = value;
      rows[row]['rowNumber'] = row;
    }
    return rows.filter(Boolean);
  };

  const getOnload = (file) => async (e) => {
    decodedExcelFile.current = getRows(e);
    const { rowNumber, ...rest } = decodedExcelFile.current[0];
    const template = templateExcel(rest, decodedExcelFile.current, currentLoadBalance?.periodType);
    await dispatch(setSelectedRowKeys([]));
    await dispatch(setSelectedBalanceUploadDetails([]));
    await dispatch(setExcelNoError(true));
    await dispatch(resetExcelUploadErrorMessages());
    await dispatch(resetExcelUploadExcelErrorGroupMessages());
    switch (template) {
      case 'MountlyExcel':
        await MountlyExcel(
          excelParams,
          file,
          dispatch,
          afterUpload,
          vouId,
          isCompliments || isMarket,
        );
        return;
      case 'DailyExcel':
        await DailyExcel(excelParams, file, dispatch, afterUpload, vouId);
        return;
      case 'SpecialExcel':
        await SpecialExcel(decodedExcelFile, setColumns, setIsOpenExcelColumnChoiceModal);
        return;
    }
  };

  const beforeUpload = useCallback(
    (file) => {
      if (!file.name.toLowerCase().endsWith('.xlsx')) {
        errorDialog({
          title: <Text t="error" />,
          message: pleaseUploadXlsxFormatFile,
        });
        return false;
      }
      lastUploadedFile.current = file;
      const reader = new FileReader();
      reader.onload = getOnload(file);
      reader.readAsArrayBuffer(file);
      return false;
    },
    [currentLoadBalance, pleaseUploadXlsxFormatFile],
  );

  const uploadComponentChange = useCallback((info) => {
    if (!info.file.name.toLowerCase().endsWith('.xlsx')) {
      return false;
    }
    setUploadedExcelFile(null);
  }, []);

  useEffect(async () => {
    await dispatch(createExcelGroupErrors());
  }, [excelUploadErrorMessages.length]);

  const steps = [
    {
      selector: '.error-messages-wrapper',
      title: '',
      description: fixTheseErrorsToContinueBalanceLoading,
    },
    {
      selector: '.file-upload-area',
      title: '',
      description: fixErrorsInYourUploadedExcelAndReupload,
    },
    {
      selector: '.excel-upload-table .ant-collapse-content-box',
      title: '',
      description: youCanAlsoFixErrorsByEditingRedMarkedAreas,
    },
  ];

  const customFooterRenderer = (tourLogic) => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: '12px',
          color: '#3c4655',
        }}
      >
        <button
          className={'tourPrev'}
          style={{
            textDecoration: 'underline',
            ...(tourLogic.stepIndex === 0 ? { color: '#dedede' } : { cursor: 'pointer' }),
            borderWidth: 0,
            backgroundColor: 'transparent',
          }}
          onClick={() => tourLogic.prev()}
        >
          {tourLogic.stepContent.prevLabel}
        </button>
        {tourLogic.stepIndex + 1 === tourLogic.allSteps.length ? (
          <button
            className={'tourClose'}
            style={{
              textDecoration: 'underline',
              cursor: 'pointer',
              borderWidth: 0,
              backgroundColor: 'transparent',
            }}
            onClick={() => tourLogic.close(true)}
          >
            {tourLogic.stepContent.closeLabel}
          </button>
        ) : (
          <button
            className={'tourNext'}
            style={{
              textDecoration: 'underline',
              cursor: 'pointer',
              borderWidth: 0,
              backgroundColor: 'transparent',
            }}
            onClick={() => tourLogic.next()}
          >
            {tourLogic.stepContent.nextLabel}
          </button>
        )}
      </div>
    );
  };

  const customDescriptionRenderer = (description, tourLogic) => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          position: 'relative',
          paddingBottom: '10px',
          fontFamily: 'Ubuntu, sans-serif',
        }}
      >
        <div style={{ color: '#3f4957', marginTop: '16px' }}>{description}</div>
        <CustomImage
          onClick={() => tourLogic.close()}
          src={modalClose}
          style={{ cursor: 'pointer', width: '16px', position: 'absolute', right: 0, top: 0 }}
        />
      </div>
    );
  };

  const hasUploadError = excelUploadErrorMessages && excelUploadErrorMessages.length > 0;

  const showUploadedFile = Boolean(uploadedExcelFile);
  const showWaitingMessage = !uploadedExcelFile && !(isCompliments || isMarket);

  let uploadContent = null;

  if (showUploadedFile) {
    uploadContent = (
      <div className="file-upload-success">
        <span>
          <CustomImage src={hasUploadError ? iconFail : iconSuccess} style={{ width: '16px' }} />
        </span>
        <span className="uploaded-file-name">
          {uploadedExcelFile} <Text t="uploaded" />
        </span>
      </div>
    );
  } else if (showWaitingMessage) {
    uploadContent = (
      <div className="file-upload-waiting">
        <span className="uploaded-file-name">
          <Text t="xlsxMaximumFileSize100Mb" />
        </span>
      </div>
    );
  }

  return (
    <div className="excel-upload-card">
      {excelUploadErrorMessages.length > 0 && isFirstExcelUpload && (
        <Walktour
          maskRadius={10}
          customFooterRenderer={customFooterRenderer}
          customDescriptionRenderer={customDescriptionRenderer}
          steps={steps}
          prevLabel={previousLabel}
          nextLabel={nextLabel}
          closeLabel={closeLabel}
        />
      )}
      <CustomCollapseCard
        cardTitle={excelUploadAreaTitle}
        className="excel-upload-table-upload-file-area"
        cardTitleAlign={isCompliments || isMarket ? 'center' : 'left'}
        showExpandIcon={!(isCompliments || isMarket)}
      >
        <div className="header-btn">
          <span>
            <Text t="whenYouDownloadTheBalanceLoadingTemplateThe" />
          </span>
          <CustomButton
            id="ticketRestaurant-balanceUpload-balanceInformation-excelUpload-download-btn"
            className="download-btn"
            onClick={downloadActiveCards}
          >
            <CustomImage src={downloadIcon} />
            <Text t="downloadTemplate" />
          </CustomButton>
        </div>
        <div className="long-line" />
        <div className="file-upload-area">
          <div className="header-btn">
            <span style={{ lineHeight: '1.14', fontFamily: 'Ubuntu, sans-serif' }}>
              <Text t="continueYourBalanceLoadingProcessByUploadingThe" />
              {uploadedExcelFile && !excelParams.current.UseDefaultTemplate && (
                <span>
                  {' '}
                  <Text t="youCanClickMatchColumnsToRedoThe" />
                </span>
              )}
            </span>
            <div className="upload-buttons">
              {uploadedExcelFile && !excelParams.current.UseDefaultTemplate && (
                <CustomButton
                  onClick={() => {
                    setIsOpenExcelColumnChoiceModal(true);
                  }}
                  className={'custom-excel-reassign-button'}
                >
                  <Text t="matchColumns" />
                </CustomButton>
              )}
              <Upload
                className={'custom-excel-upload-btn'}
                showUploadList={false}
                accept={
                  '.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }
                name="line"
                onChange={uploadComponentChange}
                beforeUpload={beforeUpload}
              >
                <CustomButton
                  style={{ width: isCompliments || isMarket ? 176 : '100%' }}
                  className={'custom-excel-upload-button'}
                  type="primary"
                >
                  <Text t="selectFile" />
                </CustomButton>
              </Upload>
            </div>
          </div>
          {uploadContent}
        </div>

        {hasUploadError ? (
          <div className="error-messages-wrapper">
            <div className="error-messages">
              <CustomImage src={errorUpload} className="main-rectangle" />
              <div className="errors-body">
                <div className="message-detail-list">
                  <p>
                    <Text t="inTheFileYouUploaded" />{' '}
                    <strong> {excelUploadErrorMessages?.length} </strong>{' '}
                    <Text t="errorsWereFoundErrorDetailsAreAsFollows" />
                  </p>
                </div>
              </div>
            </div>
            <div className="message-list">
              <ul
                id="ticketRestaurant-balanceUpload-balanceInformation-excelUpload-message-list-ul"
                style={{ marginLeft: '-0.5rem' }}
              >
                {excelUploadExcelErrorGroupMessages
                  ?.filter((errorMessage) => errorMessage !== '')
                  ?.map((item, i) => (
                    <li
                      id={`ticketRestaurant-balanceUpload-balanceInformation-excelUpload-message-list-${i}-li`}
                      key={item}
                      className="info-text-list"
                    >
                      {item}
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        ) : null}
      </CustomCollapseCard>
      {isUploadedExcelFile && (
        <ExcelUploadTable
          isCompliments={isCompliments}
          isMarket={isMarket}
          decodedExcelFile={decodedExcelFile}
          excelParams={excelParams}
        />
      )}

      {isOpenExcelColumnChoiceModal && (
        <ExcelUploadColumnChoiceModal
          modalVisible={isOpenExcelColumnChoiceModal}
          handleModalVisible={setIsOpenExcelColumnChoiceModal}
          excelFile={lastUploadedFile}
          excelParams={excelParams}
          decodedExcelFile={decodedExcelFile}
          columns={columns}
          afterUpload={afterUpload}
          isCompliments={isCompliments || isMarket}
          isMarket={isMarket}
        />
      )}
    </div>
  );
};
ExcelUpload.propTypes = {
  isCompliments: PropTypes.bool,
  isMarket: PropTypes.bool,
};

export default ExcelUpload;
